import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { CalendarDays, LogOut, LayoutDashboard, BarChart3, ShoppingBag, MapPin } from "lucide-react";

export default function AdminLayout() {
  const { admin, logout, loading } = useAdminAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-[#333] border-t-[#D8C08F] rounded-full animate-spin" />
      </div>
    );
  }

  if (!admin) {
    navigate("/admin/login");
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-sans transition-colors ${
      isActive
        ? "bg-[#1a1a1a] text-[#D8C08F]"
        : "text-[#888] hover:text-white hover:bg-[#1a1a1a]/50"
    }`;

  return (
    <div className="min-h-screen bg-[#0f0f0f] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-56 bg-[#0a0a0a] border-r border-[#1a1a1a] flex flex-col p-4 shrink-0">
        <div className="mb-8 px-2">
          <h2 className="text-white text-base font-sans font-semibold tracking-tight">
            ShopThing
          </h2>
          <p className="text-[#555] text-xs font-sans mt-0.5">Admin Panel</p>
        </div>

        <nav className="flex flex-col gap-1 flex-1" data-testid="admin-nav">
          <NavLink to="/admin" end className={linkClass} data-testid="nav-dashboard">
            <LayoutDashboard size={18} />
            Dashboard
          </NavLink>
          <NavLink to="/admin/events" className={linkClass} data-testid="nav-events">
            <CalendarDays size={18} />
            Events
          </NavLink>
          <NavLink to="/admin/orders" className={linkClass} data-testid="nav-orders">
            <ShoppingBag size={18} />
            Orders
          </NavLink>
          <NavLink to="/admin/delivery" className={linkClass} data-testid="nav-delivery">
            <MapPin size={18} />
            Доставка
          </NavLink>
          <NavLink to="/admin/analytics" className={linkClass} data-testid="nav-analytics">
            <BarChart3 size={18} />
            Analytics
          </NavLink>
        </nav>

        <div className="border-t border-[#1a1a1a] pt-4 mt-4">
          <p className="text-[#555] text-xs font-sans px-2 mb-2 truncate">
            {admin.email}
          </p>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-sans text-[#888] hover:text-red-400 hover:bg-red-500/10 transition-colors w-full"
            data-testid="logout-button"
          >
            <LogOut size={18} />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto p-6 max-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
